<div
  class="news_category p-top-20 p-x-20 dis_flex flex_wrap"
  *ngIf="data && showNews"
>
  <ng-container *ngFor="let category of data | keyvalue">
    <div class="news_category_item p-top-40 p-x-20 width_full">
      <div
        class="dis_flex jc_space_bet border_bottom_blue_1 align_items_center"
      >
        <div
          class="p-bot-10 p-r-10 border_bottom_pink_5 width_fit color_black font_20 weight_700"
        >
          {{ category.key }}
        </div>

        <div
          class="color_blue font_14 weight_600 cursor_pointer"
          (click)="goToCategoryPage(category.value[0]?.categoryId)"
        >
          View All
        </div>
      </div>

      <!-- News items under each category -->
      <ng-container *ngFor="let news of category.value">
        <div
          class="p-t-32 dis_flex cursor_pointer"
          (click)="goToNewsDetail(news.slug || news._id)"
        >
          <img
            class="width_120 aspect_ratio_1 border-radius-6"
            [src]="news.imgPath || filePath + news.thumbnailImage"
            alt="{{ news.title }}"
          />

          <!-- News details -->
          <div class="color_black p-l-25">
            <div class="font_12 weight_500">
              {{ news.news_date | date: "mediumDate" }}
            </div>
            <div class="p-top-8 font_16 weight_600">
              {{ news.title }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </ng-container>
</div>
